export default __webpack_public_path__ + "static/media/email_twitter.297f4f8b.svg";